import "../../font.css.ts.vanilla.mjs";
import "./baseConfig/global.css.ts.vanilla.mjs";
import "./tag.css.ts.vanilla.mjs";
var t = "p273__tag-4a26_fc0e213b2__1agkr7o1", e = "p273__tag-4a26_fc0e213b2__1agkr7o0", g = "p273__tag-4a26_fc0e213b2__1agkr7o2";
export {
  t as darkTheme,
  e as lightTheme,
  g as tagStyle
};
//# sourceMappingURL=tag.mjs.map
